import React, { useState } from 'react';
import { DatePicker, message, Space } from 'antd';
import InfoModal from './infoModal';
import moment from 'moment';

interface Props {
	visible: boolean;
	onCancel: () => void;
	onOk: (date: moment.Moment) => Promise<void>;
}

export const DateSelectModal: React.FC<Props> = ({ visible, onCancel, onOk }) => {
	const [date, setDate] = useState<moment.Moment>();
	const [time, setTime] = useState<moment.Moment>();
	const [loading, setLoading] = useState(false);

	const approve = async () => {
		if (!date) {
			message.error('Nie wybrano daty');
			return;
		}

		const d = date?.clone().seconds(0).milliseconds(0);
		if (!time) {
			d.hours(0).minutes(0);
		} else {
			d.hours(time.hours()).minutes(time.minutes());
		}

		try {
			setLoading(true);
			await onOk(d);

			setDate(undefined);
			setTime(undefined);
		} finally {
			setLoading(false);
		}
	};

	const cancel = () => {
		setDate(undefined);
		setTime(undefined);
		onCancel();
	};

	return (
		<InfoModal
			visible={visible}
			closable={false}
			cancelText="Anuluj"
			okText="Edytuj"
			onCancel={cancel}
			onOk={approve}
			disabled={date === undefined}
			loading={loading}
		>
			<h1>Edytuj datę?</h1>
			<div className="input">
				Data:
				<Space size={20}>
					<DatePicker size="large" placeholder="Wybierz datę" value={date ?? null} onChange={(m) => m && setDate(m)} />
					<DatePicker.TimePicker
						size="large"
						format="HH:mm"
						placeholder="Wybierz godzinę"
						value={time ?? null}
						onChange={(m) => setTime(m ?? undefined)}
					/>
				</Space>
			</div>
		</InfoModal>
	);
};
